var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, reaction, makeObservable, } from 'mobx';
import { runtime } from '../../classes/runtime/Runtime';
import { bound } from '../decorators/basic';
export class Reaction {
    when;
    action;
    fireImmediately = true;
    delay = undefined;
    equals;
    name;
    onError;
    scheduler;
    onlyIfTrue = false;
    setupWhenIdle = false;
    checkEveryMilliseconds = 0;
    disposeWhen;
    disposer;
    constructor(init) {
        makeObservable(this);
        Object.assign(this, init);
        if (this.setupWhenIdle) {
            runtime.runtimeScheduler.addToNextIdleStateChange(() => this.setupReaction());
        }
        else {
            this.setupReaction();
        }
        if (this.disposeWhen) {
        }
    }
    enhancedAction(isTrue, r) {
        if (this.onlyIfTrue && !isTrue) {
            return;
        }
        return this.action(isTrue, r);
    }
    get enhancedWhen() {
        const result = this.when();
        if (this.onlyIfTrue && !result)
            return false;
        if (this.checkEveryMilliseconds > 0) {
            const x = runtime.runtimeClock.getCustomClock(this.checkEveryMilliseconds).tickingTime;
        }
        return result;
    }
    setupReaction() {
        this.disposer = reaction(() => this.enhancedWhen, this.enhancedAction, {
            fireImmediately: this.fireImmediately,
            delay: this.delay,
            equals: this.equals,
            name: this.name,
            onError: this.onError,
            scheduler: this.scheduler,
        });
    }
    dispose() {
        if (this.disposer) {
            this.disposer();
        }
    }
}
__decorate([
    action.bound
], Reaction.prototype, "enhancedAction", null);
__decorate([
    computed
], Reaction.prototype, "enhancedWhen", null);
__decorate([
    bound
], Reaction.prototype, "setupReaction", null);
__decorate([
    bound
], Reaction.prototype, "dispose", null);
